<template>
    <section class="login-page-area">

        <div class="bubble-box">
            <div class="bubbles-1"></div>
            <div class="bubbles-2"></div>
            <div class="bubbles-3"></div>
            <div class="bubbles-4"></div>
            <div class="bubbles-5"></div>
            <div class="bubbles-7"></div>
        </div>

        <div class="container">
            <div class="row login-wrapper">
                <!-- Login Area Start-->
                <div class="col-6col-12 col-sm-12 col-md-6 login-form-1">
                    <h3>Login Here</h3>
                   
                    <form id="login-form" method="post" @submit.prevent="loginFormSubmit" autocomplete="off"> 
                        <span class="input input--nao">
                            <input class="input__field input__field--nao" type="email" v-model.trim="$v.formData.email.$model" placeholder="Email"/>
                            <svg class="graphic graphic--nao" :class="(!formStatus && $v.formData.email.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                                <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
                            </svg>
                        </span>
                        <p class="form-error" v-if="!formStatus && $v.formData.email.$error && !$v.formData.email.required">Please Enter your email!</p>
                        <p class="form-error" v-if="!formStatus && $v.formData.email.$error && !$v.formData.email.email">Invalid Email Address!</p>
                                                
                        <span class="input input--nao">
                            <input class="input__field input__field--nao" type="password" v-model.trim="$v.formData.password.$model" placeholder="Password" />
                            <svg class="graphic graphic--nao" :class="(!formStatus && $v.formData.password.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                                <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
                            </svg>
                        </span>
                        <p class="form-error" v-if="!formStatus && $v.formData.password.$error && !$v.formData.password.required">Please Enter your password!</p>
                        <p class="form-error" v-if="!formStatus && $v.formData.password.$error && !$v.formData.password.minLength">Password must be {{$v.formData.password.$params.minLength.min}} digits or long!</p>
                         
                        <!--message-area-->
                        <div class="d-flex message-button-wrap mt-5">
                            <div class="subm-btn theme-button">
                                <input type="submit" class="btn contact-btn" value="Submit">
                            </div>
                        </div>

                        <div class="form-group">
                            <p class="login-yet">Forgot Password? 
                                <router-link to="/account/login">Click Here</router-link>
                            </p>
                        </div>
                        <div class="resMssg text-center" v-html="formResponse"></div>
                    </form>
                </div>
                <!-- Login Area End-->
            </div>
        </div>
    </section>
</template>


<script>
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
    data() {
        return {
            formData: {
                email: '',
                password:''
            },
            formResponse: '',
            formStatus: true
        }
    },
    validations: {
        formData: {
            email: {required,email},
            password: {required, minLength: minLength(6)},
        }
    },
    methods: {
        loginFormSubmit(){
            this.formStatus = false
            this.$v.$touch()
            if(!this.$v.$invalid){      
                document.querySelector('.resMssg').style.display = 'block'
                this.$store.dispatch('authentication', this.formData)
                    .then(res=>{            
                        if(res.status === 200){
                            this.resMsg = res.data.message;
                            this.formResponse =`<span class="alert alert-success">${res.data.message}</span>`  
                            this.resetForm()
                            setTimeout(()=>{
                                this.$router.push('dashboard')
                            }, 3000);                        
                        }
                        else {
                            this.formResponse =`<span class="alert alert-danger">${res.data.error}</span>`
                        }
                        
                    }).catch(err=>{
                        if(err.response.status === 500)
                            this.formResponse =`<span class="alert alert-danger">Internal Server Error!</span>`
                        else
                            this.formResponse =`<span class="alert alert-danger">${err.response.data.error}</span>`
                    })

                this.togellingResponse();
            }
        },
        togellingResponse(){
            setTimeout(()=>{
                document.querySelector('.resMssg').style.display = 'none'
            }, 5000)
        },
        resetForm(){
            Object.keys(this.formData).forEach(item=>{
                this.formData[item] = ''
            })    
        }
    }
}
</script>

<style scoped>
.form-error{
    color: #f00; font-size: 0.7rem;
}
.input__field{height:50px;}
.error-stroke{stroke:#f00;}
.login-wrapper .input--nao {
    margin-bottom: 0;
    padding: 10px 0;
}
</style>